import { Box, BoxProps } from "@chakra-ui/react";
import { FiExternalLink } from "react-icons/fi";

export const Link = (props: BoxProps) => {
  return <Box as={FiExternalLink} height="20px" width="20px" {...props} />;
};
